import React, { useEffect, useState } from 'react';

import ExtendableGroup from './extendable-group';

interface ExtendableGroupAutoProps {
  label: string;
  children: React.ReactNode;
  childRef: React.RefObject<HTMLDivElement | null>;
  onToggle?: () => void;
}

const ExtendableGroupAuto = ({ label, children, childRef, onToggle }: ExtendableGroupAutoProps) => {
  const [userInteracted, setUserInteracted] = useState(false);
  const [extended, setExtended] = useState(false);
  const expandableMaxHeight = 350; // Max height set in px

  useEffect(() => {
    if (!userInteracted && childRef && childRef.current) {
      if (expandableMaxHeight < childRef.current.clientHeight) {
        setExtended(false);
      } else {
        setExtended(true);
      }
    }
  }, [children]);

  const _onToggle = () => {
    setUserInteracted(true);

    if (onToggle) {
      onToggle();
    }
  };

  return (
    <ExtendableGroup label={label} extended={extended} onToggle={_onToggle}>
      {children}
    </ExtendableGroup>
  );
};

export default ExtendableGroupAuto;
